import { Node } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import LSDBButtonView from "./LSDBButtonView";

const LsdbButtonExtension = Node.create({
  name: "lsdbButton",

  group: "block",

  atom: true,

  draggable: true,

  addAttributes() {
    return {
      name: {
        default: null,
      },

      text: {
        default: "PULL FROM LSDB",
      },

      url: {
        default: "",
      },

      prefill: {
        default: false,
      },

      is_image: {
        default: false,
      },

      alignment: {
        default: "right",
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "lsdb-button",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["lsdb-button", HTMLAttributes];
  },

  addNodeView() {
    return ReactNodeViewRenderer(LSDBButtonView);
  },
});

export default LsdbButtonExtension;
